// src/data/biologyExperiments.js

const BIOLOGY_EXPERIMENTS = {
  6: [
    {
      id: "flower_parts_microscope",
      classLevel: 6,
      title: "Observation of Parts of a Flower",
      description:
        "Observe main parts of a flower using a prepared slide under a microscope.",
      apparatus: "microscope",
      actionLabel: "Drag and drop the flower slide onto the microscope viewer.",
      specimens: [
        {
          id: "flower_slide",
          name: "Flower Slide",
          color: "#ec4899",
          emoji: "🌸",
          image: "flower_slide.png",
        },
      ],
      correctSpecimenId: "flower_slide",
      observation:
        "Sepals, petals, stamens with pollen grains and the pistil are clearly visible.",
      successMessage:
        "These are the main visible parts of a flower involved in reproduction.",
      steps: ["Drag the flower slide", "Observe the parts under the microscope"],
    },
    {
      id: "microorganisms_in_pondwater",
      classLevel: 6,
      title: "Micro-organisms in Pond Water",
      description: "Observe tiny organisms present in pond water.",
      apparatus: "microscope",
      actionLabel:
        "Drag and drop the pond water slide onto the microscope viewer.",
      specimens: [
        {
          id: "pond_water_slide",
          name: "Pond Water Slide",
          color: "#0ea5e9",
          emoji: "💧",
          image: "pond_water_slide.png",
        },
      ],
      correctSpecimenId: "pond_water_slide",
      observation:
        "Many small, moving shapes such as protozoa and algae can be seen.",
      successMessage:
        "These are micro-organisms that cannot be seen with the naked eye.",
      steps: ["Drag the pond water slide", "Observe moving micro-organisms"],
    },
  ],

  7: [
    {
      id: "nutrition_in_leaf",
      classLevel: 7,
      title: "Observation of Starch in Leaves",
      description:
        "Observe blue-black iodine staining of starch in a leaf slide.",
      apparatus: "slide",
      actionLabel: "Drag and drop the stained leaf slide into the slide viewer.",
      specimens: [
        {
          id: "stained_leaf",
          name: "Iodine-stained Leaf Slide",
          color: "#22c55e",
          emoji: "🌿",
          image: "stained_leaf.png",
        },
      ],
      correctSpecimenId: "stained_leaf",
      observation:
        "Blue-black stained regions show the presence of starch in the leaf.",
      successMessage:
        "Starch formation indicates that photosynthesis has taken place.",
      steps: ["Drag the stained leaf slide", "See blue-black starch areas"],
    },
    {
      id: "respiration_in_germinating_seeds",
      classLevel: 7,
      title: "Respiration in Germinating Seeds",
      description: "Model the release of carbon dioxide from germinating seeds.",
      apparatus: "petri",
      actionLabel:
        "Drag and drop the germinating seed sample onto the petri dish.",
      specimens: [
        {
          id: "germinating_seeds",
          name: "Germinating Seeds Sample",
          color: "#facc15",
          emoji: "🌱",
          image: "germinating_seeds.png",
        },
      ],
      correctSpecimenId: "germinating_seeds",
      observation:
        "The setup shows that germinating seeds release carbon dioxide during respiration.",
      successMessage:
        "Germinating seeds respire actively and release carbon dioxide.",
      steps: ["Drag the germinating seeds", "Observe the respiration effect"],
    },
  ],

  8: [
    {
      id: "animal_cell_slide",
      classLevel: 8,
      title: "Observation of Animal Cell",
      description:
        "Observe a stained animal cell slide and identify membrane, cytoplasm and nucleus.",
      apparatus: "slide",
      actionLabel:
        "Drag and drop the animal cell slide into the slide viewer area.",
      specimens: [
        {
          id: "animal_cell",
          name: "Animal Cell Slide",
          color: "#6366f1",
          emoji: "🧬",
          image: "animal_cell.png",
        },
      ],
      correctSpecimenId: "animal_cell",
      observation:
        "You can clearly see the cell membrane, cytoplasm and a central nucleus.",
      successMessage:
        "Animal cells have a cell membrane, cytoplasm and nucleus but no cell wall.",
      steps: ["Drag the animal cell slide", "Observe its main cell parts"],
    },
    {
      id: "microorganisms_friendly_harmful",
      classLevel: 8,
      title: "Useful Micro-organisms (Yeast Culture)",
      description:
        "Observe growth of yeast colonies on nutrient medium in a petri dish.",
      apparatus: "petri",
      actionLabel:
        "Drag and drop the yeast culture sample into the petri dish area.",
      specimens: [
        {
          id: "yeast_culture",
          name: "Yeast Culture Sample",
          color: "#f97316",
          emoji: "🍞",
          image: "yeast_culture.png",
        },
      ],
      correctSpecimenId: "yeast_culture",
      observation:
        "Yeast grows into round colonies on the nutrient medium surface.",
      successMessage:
        "Yeast is a useful micro-organism used in baking and fermentation.",
      steps: ["Drag the yeast culture", "Observe colonies growing in the dish"],
    },
  ],

  9: [
    {
      id: "plant_tissue_slide",
      classLevel: 9,
      title: "Observation of Plant Tissue (Parenchyma)",
      description:
        "Observe plant parenchyma tissue and note its thin walls and large vacuoles.",
      apparatus: "slide",
      actionLabel:
        "Drag and drop the parenchyma tissue slide into the slide viewer.",
      specimens: [
        {
          id: "parenchyma_slide",
          name: "Plant Parenchyma Slide",
          color: "#22c55e",
          emoji: "🌿",
          image: "parenchyma_slide.png",
        },
      ],
      correctSpecimenId: "parenchyma_slide",
      observation:
        "Parenchyma cells have thin cell walls, are loosely packed and contain large vacuoles.",
      successMessage:
        "Parenchyma tissue helps in storage and sometimes in photosynthesis.",
      steps: ["Drag the parenchyma slide", "Observe the typical parenchyma cells"],
    },
    {
      id: "aerobic_respiration",
      classLevel: 9,
      title: "Demonstration of Aerobic Respiration",
      description:
        "Model heat production during aerobic respiration in germinating seeds.",
      apparatus: "petri",
      actionLabel:
        "Drag and drop the germinating seed sample into the chamber area.",
      specimens: [
        {
          id: "germinating_seeds",
          name: "Germinating Seeds Sample",
          color: "#facc15",
          emoji: "🌱",
          image: "germinating_seeds.png",
        },
      ],
      correctSpecimenId: "germinating_seeds",
      observation:
        "The model shows a rise in temperature in the setup with germinating seeds.",
      successMessage:
        "Aerobic respiration is an exothermic process and releases heat.",
      steps: ["Drag the germinating seeds", "Observe the temperature change model"],
    },
  ],

  10: [
    {
      id: "dna_extraction_fruit",
      classLevel: 10,
      title: "DNA Extraction from Fruit (Model Activity)",
      description:
        "Model the appearance of DNA strands when fruit extract is treated with alcohol.",
      apparatus: "microscope",
      actionLabel:
        "Drag and drop the strawberry extract sample into the viewer setup.",
      specimens: [
        {
          id: "strawberry_sample",
          name: "Strawberry Extract Sample",
          color: "#fb7185",
          emoji: "🍓",
          image: "strawberry_sample.png",
        },
      ],
      correctSpecimenId: "strawberry_sample",
      observation:
        "White, threadlike DNA strands appear and separate out in the mixture.",
      successMessage:
        "This shows that DNA is present in the cells of living organisms.",
      steps: ["Drag the strawberry sample", "Observe white DNA strands forming"],
    },
    {
      id: "osmosis_potato",
      classLevel: 10,
      title: "Demonstration of Osmosis with Potato",
      description:
        "Observe water movement into a potato cup containing concentrated sugar solution.",
      apparatus: "petri",
      actionLabel:
        "Drag and drop the potato cup with sugar solution into the dish.",
      specimens: [
        {
          id: "sugar_potato",
          name: "Potato Cup with Sugar Solution",
          color: "#fbbf24",
          emoji: "🥔",
          image: "sugar_potato.png",
        },
      ],
      correctSpecimenId: "sugar_potato",
      observation:
        "Water enters the potato cup and the liquid level in the cavity rises.",
      successMessage:
        "This demonstrates osmosis: water moves from higher to lower water concentration.",
      steps: ["Drag the potato cup sample", "Observe the rise in liquid level"],
    },
  ],
};

export default BIOLOGY_EXPERIMENTS;
